export default "__VITE_ASSET__774732bc__"